module.exports = __webpack_public_path__ + "img/carousel-image-3.fe539bdf.jpg";